/**
 * Base dataLayer object for Adobe Analytics
 * @param {object} cart - completed cart object
 * @returns {object} - base dataLayer object
 */
export default (cart) => ({
	account: cart.app.env === 'prod' ? 'symanteccom' : 'veritasdev',
	site_country: cart.url.region,
	site_language: cart.url.language,
	content_title: document.title,
	content_format: 'html',
	content_type: 'page',
	userflow: cart.url.brand,
	site_section: `checkout ${cart.url.brand}`,
	site_sub_section: 'cart',
	store_cartdesign: `${cart.theme?.name || null}-${cart.order?.flow || null}`,
	spa: true
});
